import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Address } from '@vendasta/businesses';
import {
  IAMService,
  PhoneNumberInterface,
  PhoneNumberType,
  SetAddress,
  SetFirstName,
  SetLastName,
  SetPhoneNumbers,
  SetProfileImageUrl,
  User,
  UserIdentifier,
} from '@vendasta/iamv2';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const DEFAULT_IMAGE_URL = 'https://storage.googleapis.com/iam-user-images-demo/Profile.png';
export const STATUS_VALID = 'VALID';

export interface PlainPhoneNumber {
  phone: string;
  ext: string;
}

@Injectable()
export class UserProfileService {
  constructor(private iamService: IAMService) {}

  getUser(userUnifiedId: string): Observable<User> {
    return this.iamService.getUser(new UserIdentifier({ userId: userUnifiedId }));
  }

  updateUser(
    userUnifiedId: string,
    firstName: string,
    lastName: string,
    addrs: Address,
    stringPhones?: string[],
  ): Observable<HttpResponse<null>> {
    const phoneNumbers = stringPhones
      .map((phoneNumber) => {
        if (phoneNumber) {
          return {
            phoneNumber: phoneNumber,
            phoneNumberType: PhoneNumberType.PHONE_NUMBER_TYPE_HOME,
          } as PhoneNumberInterface;
        }
      })
      .filter((pn) => pn !== undefined);

    const newAddress = addrs
      ? {
          address: addrs.address1,
          additionalAddress: addrs.address2,
          city: addrs.city,
          country: addrs.country,
          state: addrs.province !== '' ? addrs.country + '-' + addrs.province : '',
          postalCode: addrs.zip,
        }
      : {};

    return this.iamService.updateUser(new UserIdentifier({ userId: userUnifiedId }), [
      SetFirstName(firstName),
      SetLastName(lastName),
      SetPhoneNumbers(phoneNumbers),
      SetAddress(newAddress),
    ]);
  }

  updateUserImage(userUnifiedId: string, imageURL: string): Observable<HttpResponse<null>> {
    return this.iamService.updateUser(new UserIdentifier({ userId: userUnifiedId }), [SetProfileImageUrl(imageURL)]);
  }

  updatePassword(userUnifiedId: string, currentPassword: string, newPassword: string): Observable<boolean> {
    return this.iamService
      .changePassword(new UserIdentifier({ userId: userUnifiedId }), currentPassword, newPassword)
      .pipe(
        map(() => true),
        catchError(() => of(false)),
      );
  }
}
